<template>
  <div>
    <b-row>
      <b-col>
        <h5>Filtrar por</h5>
      </b-col>
      <b-col sm="2">
        <downloadExcel
          class="btn btn-warning col-sm-12"
          :data="selectItems.length > 0 ? selectItems : items"
          worksheet="Analisis Cartera"
          name="analisis-cartera.xls"
          :fields="json_fields"
          >Exportar</downloadExcel
        >
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group>
          <label class="mb-0" for="cmbStatus">Estado de la cartera</label>
          <b-form-select
            v-model="status_filter"
            id="cmbStatus"
            @change="getDebtors()"
          >
            <option value="T">Todos</option>
            <option value="S">Gestionables</option>
            <option value="N">No Gestionables</option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label for="cmbEtapa" class="mb-0">Etapa de cobro</label>
          <b-form-select
            v-model="process_id_filter"
            id="cmbEtapa"
            @change="getDebtors()"
          >
            <template slot="first">
              <option :value="null">-- Etapa de cobro --</option>
            </template>
            <option v-for="item in lstProcess" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0" for="cmbCuenta">Cuenta</label>
          <b-form-select
            v-model="customer_id_filter"
            id="cmbCuenta"
            @change="getDebtors()"
          >
            <template slot="first">
              <option :value="null">
                -- Por favor seleccione una opción --
              </option>
            </template>

            <option
              v-for="item in lstCustomers"
              :key="item.id"
              :value="item.id"
            >
              {{ item.business_name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col v-if="role_id == 1 || role_id == 8">
        <b-form-group>
          <label class="mb-0">Cobrador / Abogado</label>
          <b-form-select v-model="staff_id_filter" @change="getDebtors()">
            <template slot="first">
              <option :value="null">-- Responsable--</option>
            </template>
            <option v-for="item in lstStaffs" :key="item.id" :value="item.id">
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label for="cmbStaff" class="mb-0">Comercial</label>
          <b-form-select
            v-model="customer_staff_id_filter"
            id="cmbStaff"
            @change="getDebtors()"
          >
            <template slot="first">
              <option :value="null">-- Comercial --</option>
            </template>
            <option
              v-for="item in lstComercialStaffs"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="card-group mb-4">
      <div class="card card-accent-primary">
        <div class="card-body">
          <div class="text-value">
            $ {{ formatPrice(summary.capital_by_recovered) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >CAPITAL DISPONIBLE</small
          >
          <!-- <hr />
          <div class="text-value">
            $ {{ summary.capital_percent }} %
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >% CAPITAL COBRADO</small
          >
        </div> -->
      </div>

      <!-- <div class="card card-accent-warning">
        <div class="card-body">
          <div class="text-value">
            $ {{ formatPrice(summary.interests_recovered) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >INTERÉS RECUPERADO</small
          >
          <hr />
          <div class="text-value">
            $ {{ summary.interests_percent }} %
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >% INTERÉS RECUPERADO</small
          >
        </div>
      </div>

      <div class="card card-accent-info">
        <div class="card-body">
          <div class="text-value">
            $ {{ formatPrice(summary.fees_recovered) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >HONORARIOS COBRADOS</small
          >
          <hr />
          <div class="text-value">
            $ {{ summary.fees_percent }} %
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >% HONORARIOS COBRADOS</small
          >
        </div> -->
      </div>
    </div>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">
            <div v-if="isAdmin">
              <div class="row" v-if="selectItems.length > 0">
                <div class="col-sm-2">
                  <downloadExcel
                    class="btn btn-warning col-sm-12 mb-2"
                    :data="selectItems"
                    worksheet="Indicadores"
                    name="indicators.xls"
                    :before-generate="startDownload"
                    :before-finish="finishDownload"
                    >Exportar</downloadExcel
                  >
                </div>
              </div>
            </div>

            <div>
              <b-table
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                responsive
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
              >
                <template slot="HEAD_selected" v-if="isAdmin">
                  <input
                    type="checkbox"
                    @click.stop
                    v-model="selectAll"
                    @change="toggleSelectAll"
                  />
                </template>

                <template slot="selected" slot-scope="data" v-if="isAdmin">
                  <input
                    type="checkbox"
                    v-model="data.item.selected"
                    @change="selectRow(data.item)"
                  />
                </template>

                <!-- CAPITAL -->
                <template slot="capital_recover" slot-scope="data"
                  >${{ formatPrice(data.item.capital_recover) }}</template
                >
                <template slot="capital_recovered" slot-scope="data"
                  >${{ formatPrice(data.item.capital_recovered) }}</template
                >
                <template slot="capital_by_recovered" slot-scope="data"
                  >${{ formatPrice(data.item.capital_by_recovered) }}</template
                >

                <!-- INTERES -->
                <template slot="interest" slot-scope="data"
                  >${{ formatPrice(data.item.interest) }}</template
                >
                <template slot="interests_recovered" slot-scope="data"
                  >${{ formatPrice(data.item.interests_recovered) }}</template
                >
                <template slot="interests_by_recovered" slot-scope="data"
                  >${{ formatPrice(data.item.interests_by_recovered) }}</template
                >
                
                <!-- HONORARIOS -->
                <template slot="fee" slot-scope="data"
                  >${{ formatPrice(data.item.fee) }}</template
                >
                <template slot="fees_recovered" slot-scope="data"
                  >${{ formatPrice(data.item.fees_recovered) }}</template
                >
                <template slot="fees_by_recovered" slot-scope="data"
                  >${{ formatPrice(data.item.fees_by_recovered) }}</template
                >

              </b-table>
            </div>
            <hr />
            <div class="row">
              <div class="col-sm-4">
                Mostrando
                {{
                  getRowCount(items) > perPage * currentPage
                    ? perPage * currentPage
                    : getRowCount(items)
                }}
                de {{ getRowCount(items) }} registros
              </div>
              <div class="col-sm-8">
                <nav>
                  <b-pagination
                    size="sm"
                    align="right"
                    :total-rows="getRowCount(items)"
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Anterior"
                    next-text="Siguiente"
                    :limit="10"
                  />
                </nav>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker"; //https://github.com/Innologica/vue2-daterange-picker/blob/master/src/components/DateRangePicker.vue
import moment from "moment";
export default {
  name: "SummaryPaymentsCustomer",
  components: { DateRangePicker },
  props: {
    caption: {
      type: String,
      default: "RESUMEN CARTERA POR CLIENTE",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      auth: localStorage.getItem("auth"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      isCustomer: false,

      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),

      range_payment: {
        startDate: moment(String(sumarDias(new Date(), -30))).format(
          "YYYY-MM-DD"
        ),
        endDate: moment(String(new Date())).format("YYYY-MM-DD"),
      },

      fields: [
        {
          key: "selected",
          name: "Selected",
          label: "",
          class: "options-column",
        },
        { key: "customer_business_name", label: "Cliente", sortable: true },
        
        { key: "capital_recover", label: "Capital", sortable: true },
        { key: "capital_recovered", label: "Abonos Cap.", sortable: true },
        { key: "capital_by_recovered", label: "Resta Cap.", sortable: true },

        { key: "interest", label: "Intereses", sortable: true },
        { key: "interests_recovered", label: "Abonos Int.", sortable: true },
        { key: "interests_by_recovered", label: "Resta Int.", sortable: true },

        { key: "fee", label: "Honorarios", sortable: true },
        { key: "fees_recovered", label: "Abonos Hon.", sortable: true },
        { key: "fees_by_recovered", label: "Resta Hon.", sortable: true }
      ],

      json_fields: {
        Cliente: "customer_business_name",

        "Capital": {
        field: "capital_recover",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },

        "Abonos a capital": {
          field: "capital_recovered",
          callback: (value) => {
            return `${value} %`;
          },
        },

        "Resta capital": {
          field: "capital_by_recovered",
          callback: (value) => {
            return `${value} %`;
          },
        },

        "Intereses": {
        field: "interest",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },
        
        "Abonos a intereses": {
          field: "interests_recovered",
          callback: (value) => {
            return `${value} %`;
          },
        },

        "Resta intereses": {
          field: "interests_by_recovered",
          callback: (value) => {
            return `${value} %`;
          },
        },

        "Honorarios": {
        field: "fee",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },

        "Abonos a honorarios": {
          field: "fees_recovered",
          callback: (value) => {
            return `${value} %`;
          },
        },

        "Resta honorarios": {
          field: "fees_by_recovered",
          callback: (value) => {
            return `${value} %`;
          },
        },        

      },

      items: [],
      pagination: {},
      //
      selectItems: [],
      selectAll: false,
      // FILTROS DE BUSQUEDA
      status_filter: "S",
      process_id_filter: null,
      staff_id_filter: null,
      customer_id_filter: null,
      customer_staff_id_filter: null,

      // LISTAS PARA LOS FILTROS
      lstProcess: [],
      lstStaffs: [],
      lstComercialStaffs: [],
      lstCustomers: [],

      summary: {
        capital_by_recovered: 0,
        capital_recovered: 0,
        capital_percent: 0,
        interests_recovered: 0,
        interests_percent: 0,
        fees_recovered: 0,
        fees_percent: 0
      },

      // PAGINACIÓN DE VUE
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
    };
  },
  mounted() {
    this.initParameters();
    this.getDebtors();
  },
  computed: {},
  methods: {
    initParameters() {
      // var auth = localStorage.getItem("auth");
      // auth = JSON.parse(auth);
      // this.isCustomer = authAux[0].customer_id != null ? true : false;

      // LISTA DE CUENTAS
      var auth = localStorage.getItem("auth");
      let authAux = JSON.parse(auth);
      this.isCustomer = authAux[0].customer_id != null ? true : false;
      this.staff_id_filter =
        this.role_id == 1 || this.role_id == 8 ? null : authAux[0].staff_id;

      let url = `${this.$urlApi}customers/staff?token=${this.token}`;
      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          (response) => {
            console.log(response);
            this.lstCustomers = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        );

      //LISTADO DE STAFF'S, 43: PREJURIDICO
      this.$http.get(`${this.$urlApi}staffs/type/43?token=${this.token}`).then(
        (response) => {
          this.lstStaffs = response.data.data;
          // console.log(response.data.data);
        },
        (error) => {
          console.log(error);
        }
      );

      //LISTADO DE STAFF'S, 42: COMERCIAL
      this.$http.get(`${this.$urlApi}staffs/type/42?token=${this.token}`).then(
        (response) => {
          this.lstComercialStaffs = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // PROCESOS
      this.$http.get(`${this.$urlApi}process?token=${this.token}`).then(
        (response) => {
          this.lstProcess = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

    },

    changeDateTask() {
      if (
        this.range_payment.startDate != "" &&
        this.range_payment.endDate != ""
      ) {
        this.getDebtors();
      } else return;
    },

    getDebtors: function () {

      let authAux = JSON.parse(this.auth);
      authAux[0].image = null;
       authAux[0].status = this.status_filter;
      authAux[0].staff_id_filter = this.staff_id_filter;
      authAux[0].customer_staff_id_filter = this.customer_staff_id_filter;
      authAux[0].process_id = this.process_id_filter;

      if (this.customer_id_filter) {
        authAux[0].customer_id = this.customer_id_filter;
      }

      let url = `${this.$urlApi}debtors/indicators/summarypaymentscustomer?token=${this.token}`;
      showLoader();
      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            // console.clear();
            console.log(response);
            this.items = response.data.data;
            this.summary = response.data.summary;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },

    viewDebtor(id) {
      let url = `${location.origin}/#/debtors/view/${id.toString()}`;
      window.open(url, "_blank");
    },
    startDownload() {
      showLoader();
    },
    finishDownload() {
      hideLoader();
    },
    selectRow(item) {
      if (!item.selected) {
        if (this.selectAll) {
          this.selectAll = false;
        }
        var index = this.selectItems.indexOf(item);

        if (index > -1) {
          this.selectItems.splice(index, 1);
        }
      } else {
        this.selectItems.push(item);
      }
      //console.log(this.selectItems)
    },
    toggleSelectAll() {
      if (this.selectAll) {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = true;
          this.$set(this.items, i, updatingItem);
          this.selectItems.push(updatingItem);
        }
      } else {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = false;
          this.$set(this.items, i, updatingItem);
        }
        this.selectItems = [];
      }
      //console.log(this.selectItems)
    },
    formatDateDescriotion(value) {
      if (!value) return "";
      else {
        if (value == "--") return value;
        else {
          var d = moment(value).format("DD");
          var m = moment(value).format("MMM");
          var a = moment(value).format("YYYY");
          return d + " de " + m + " " + a;
        }
      }
    },
    formatPrice(value) {
      let val = Math.trunc(value);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getRowCount(items) {
      return items.length;
    },
  },
};
</script>
